module.exports = __webpack_public_path__ + "static/media/Age of the Gods Norse Book of Dwarves.ec8c2d16.png";